import { createVNode as n, mergeProps as o } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/CheckOutlinedStandard.js";
import i from "../components/PfIcon.js";
const t = (r, e) => {
  const a = {
    ...r,
    ...e.attrs
  };
  return n(i, o(a, {
    icon: d
  }), null);
};
t.displayName = "CheckOutlinedStandard";
t.inheritAttrs = !1;
export {
  t as default
};
